import { Icon } from '../icons';

interface Props {
  onNext: () => void;
}

export function WelcomeScreen({ onNext }: Props) {
  return (
    <div className="screen">
      <div className="screen-header" style={{ paddingTop: 56 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 8,
              background: 'var(--accent)',
              display: 'grid',
              placeItems: 'center',
              color: 'white',
              fontFamily: 'Heebo',
              fontWeight: 800,
              fontSize: 14,
            }}
          >
            ר
          </div>
          <div style={{ fontFamily: 'Heebo', fontWeight: 700, fontSize: 18, letterSpacing: '-0.02em' }}>רגעים</div>
        </div>
        <button className="icon-btn" aria-label="עזרה">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
            <path
              d="M9.5 9a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5M12 17h.01"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>

      <div className="welcome-hero">
        <div className="hero-stack">
          <div className="photo">
            <div className="ph-placeholder">תמונה משפחתית</div>
          </div>
          <div className="photo">
            <div className="ph-placeholder">חתונה</div>
          </div>
          <div className="photo">
            <div className="ph-placeholder">בר מצווה</div>
          </div>
          <div className="hero-arrow">
            <Icon.Sparkles size={26} />
          </div>
        </div>

        <div className="eyebrow" style={{ marginBottom: 8 }}>
          סרטוני סיפור חיים
        </div>
        <h1 className="h1" style={{ marginTop: 0, textAlign: 'center' }}>
          הזיכרונות שלכם,
          <br />
          הופכים לסרטון
        </h1>
        <p className="lede" style={{ textAlign: 'center' }}>
          מעלים תמונות, בוחרים סגנון, ומקבלים סרטון מרגש לאירוע — תוך דקות. הכל
          בעברית.
        </p>

        <div className="welcome-features">
          <div>
            <Icon.Sparkles size={14} /> AI חכם
          </div>
          <div>
            <Icon.Music size={14} /> מוזיקה מקצועית
          </div>
          <div>
            <Icon.Heart size={14} /> ללא ידע טכני
          </div>
        </div>
      </div>

      <div className="cta-dock">
        <button className="btn-primary" onClick={onNext}>
          יוצרים סרטון ראשון
          <Icon.ArrowLeft size={18} />
        </button>
        <div style={{ textAlign: 'center', marginTop: 12, fontSize: 13, color: 'var(--ink-mute)' }}>
          כבר רשומים?{' '}
          <span style={{ color: 'var(--accent-deep)', fontWeight: 600 }}>התחברות</span>
        </div>
      </div>
    </div>
  );
}
